import React, {useEffect, useState} from 'react';
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Button from "olive-react-myoneui/lib/Button";
import BreadCrumbs from '../BreadCrumbs';
import { downloadIcon, editIcon, exclamationIcon, shareOIcon, homeIcon, documents, menuHamburgerIcon, gridIcon, versionClockIcon, uptrendIcon, leftArrowLong, searchIcon, noTestData, noReportBadgeInner} from "../../../constants/icons";
import DocFileFolderBlock from './DocFileFolderBlock';
import DocFilter from './DocFilter';
import FilesGridTable from './FilesGridTable';
import DocDetailsOffcanvas from "./DocDetailsOffcanvas";
import ActivityLogsOffcanvas from "./ActivityLogsOffcanvas";
import NoItems from "../courses/NoItems";

import ModalFolder from "./modals/ModalFolder";
import ModalShare from './modals/ModalShare';
import ModalFile from './modals/ModalFile';
import { getSharedItem, getStarredItem, postStarredItem, getItemDetails, getItemActivityLogs, postShareDocument, fetchDocumentTypeSection, postUpdateDocument, downloadDocument, uploadToAwsServer, fetchChunk, saveDocument, generateAuthToken } from '../../../../api/afterLogin/dms';
import { useSelector } from 'react-redux';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import ModalDelete from './modals/ModalDelete';
import { filterUrl } from '../../../../helpers/url_helper';
import Error403 from '../../../../modules/Error403';
import { checkDisabledSp } from '../../../../helpers/permission_helper';
import { UploadLoader } from '../../Loader';
import { getSPAuthTokens } from '../../../../helpers/spauth_token_helper';
import ToastContainer from 'olive-react-myoneui/lib/ToastContainer';
import Toast from 'olive-react-myoneui/lib/Toast';
import ToastInfo from 'olive-react-myoneui/lib/ToastInfo';

const DmsDashboard = ({ className }) => {
  const navigate = useNavigate();

  const learner   = useSelector((state) => state.user);
  const configData    = useSelector((state) => state.config);
  const products  = useSelector((state) => state.admin.products);
  const userSpEnabled = useSelector((state) => state.admin.user_sp_enabled);
  const learnerId = configData?.session?.id ?? 0;
  /* ACCESS CHECK */
  const [noAccess, setNoAccess] = useState(checkDisabledSp('dms', products, userSpEnabled));

  const [accessToken, setAccessToken] = useState('');

  const [searchParams, setSearchParams] = useSearchParams();
  const item_param = searchParams.get('item');
  const bookmark_param = searchParams.get('bookmark');

  const [keyFilter, setKeyFilter] = useState(0);

  const [keyword, setKeyword] = useState('');

  const [starred, setStarred] = useState(false);

  const [itemDetails, setItemDetails] = useState({});

  const [activityLogs, setActivityLogs] = useState({});

  const [shareItemDetail, setShareItemDetail] = useState({});

  const [fileDetail, setFileDetail] = useState({});

  const [documentTypeSection, setDocumentTypeSection] = useState({});

  const [showDetailsOffcanvas, setShowDetailsOffcanvas] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState('details');

  const [showActivityLogOffcanvas, setShowActivityLogOffcanvas] = useState(false);

  const [activeGridButton, setActiveButton] = useState("grid");

  const [isModalFolderOpen, setIsModalFolderOpen] = useState(false);
  const openModalFolder = () => setIsModalFolderOpen(true);
  const closeModalFolder = () => setIsModalFolderOpen(false);

  const [isModalShareOpen, setIsModalShareOpen] = useState(false);
  const openModalShare = () => setIsModalShareOpen(true);
  const closeModalShare = () => setIsModalShareOpen(false);

  const [isModalFileOpen, setIsModalFileOpen] = useState(false);
  const openModalFile = () => setIsModalFileOpen(true);
  const closeModalFile = () => setIsModalFileOpen(false);

  
  const [itemSharedFolder, setItemSharedFolder] = useState([]);
  const [itemSharedFile, setItemSharedFile] = useState([]);

  const [categories, setCategories] = useState([{ id: 0, name: 'All Categories' }]);

  const [showModalDelete, setShowModalDelete] = useState(false);

  const [bookmarkData, setBookmarkData] = useState({});

  const [showSuccessSnack, setShowSuccessSnack] = useState(false);
  
  const [snackBarSuccessTitle, setSnackBarSuccessTitle] = useState("Submitted Successfully");


  // upload file version
  const [file, setFile] = useState(null);
  const [uploadId, setUploadId] = useState('');
  const [parts, setParts] = useState([]);

  const [loading, setLoading] = useState(false);

  const CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB

  const toggleShowA = () => setShowSuccessSnack(!showSuccessSnack);

  const handleSortSelection = (sortType) => {
      setActiveButton(sortType);
  };

  const handleFolderClick = (item) => {
    if(bookmark_param) {
      setSearchParams({item: item.ib_item_id});
      setStarred(false);
    }else {
      setSearchParams({ item: item.id });
    }
  };
  
  const handleBack = () => {
    navigate(-1);
  };
  
  const handleOffcanvas = async (data) => {
    await fetchItemDetails(data.itemId);
    setShowDetailsOffcanvas(true); // Open the offcanvas
    setActiveTabKey(data.eventKey);
  };

  const handleDropdownClick = async (data) => {
    if(data.key === "1" && data.itemType === "0") {
      setFileDetail(data);
      openModalFolder();
    }else if(data.key === "2"){
      setShareItemDetail(data);
      openModalShare();
    }else if(data.key === "3"){
      if(data.itemDownloadUrl !== '') {
        window.open(data.itemDownloadUrl,'_blank');

        // let params = {};
        // let postParams = {
        //   "download_url": data.itemDownloadUrl
        //  }
        // await downloadDocument(configData.access_token, params, postParams,configData.dms_api_url)
      }
    }else if(data.key === "1" && data.itemType === "1") {
      setFileDetail(data);
      await getDocumentTypeSection(data.parentId);
      openModalFile();
    }else if(data.key === "4") {
      await fetchActivityLogs(data.itemId);
      setShowActivityLogOffcanvas(true);
    }
  }

  const uniqueFileName = (fileName) => {
    const date              =   new Date();
    let extension           =   fileName.split('.').pop();
    let processedFileName   =   fileName.replace('.'+extension,'');
    return cleanFileName(`${processedFileName}_${date.getUTCFullYear()}_${date.getUTCMonth() + 1}_${date.getUTCDate()}_${date.getUTCHours()}_${date.getUTCMinutes()}_${date.getUTCSeconds()}_${date.getUTCMilliseconds()}.${extension}`);
  }

  const cleanFileName = (fileName) => {
    fileName = fileName.replace(/ /g, '_');
    return fileName.replace(/[^0-9a-zA-Z\-_\.]/g, '').replace(/_+/g, '_');
  }
  
  const handleFileVersionChange = async(data) => {
    try{
      setFile(data);
    }catch(error){
      console.log("Error starting uploading", error)
    }
  }

  const uploadFile = async(file) => {
    try{
      setLoading(true);
      let uploadUrl       = file.uploadUrl;
      let itemId          = file.itemId;
      let itemParentId    = file.itemParentId;
      let fileUniqueName  = uniqueFileName(file.name);
      let fileKey         = uploadUrl+fileUniqueName;
      let params          = {
                              action: 'multipartStart',
                              fileInfo: {
                                name: file.name.replace(/[^a-z0-9.]/gi,''),
                                type: file.type,
                                size: file.size,
                                key: fileKey,
                                lastModifiedDate: file.lastModifiedDate
                              }
                            }
      const data          = await uploadToAwsServer(accessToken, {}, params, configData.dms_api_url);
      setUploadId(data.result.uploadId);
      uploadChunks(data.result.uploadId, data.result.key, fileUniqueName, file.name, itemId, itemParentId);
    }catch(error){
      setLoading(false);
      console.log("Error starting uploading", error)
    }
  }

  const uploadChunks = async(uploadId, uploadUrl, fileUniqueName, originalFileName, itemId, itemParentId) => {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    let uploadedParts = [];
    for(let i=0; i < totalChunks; i++) {
      const chunk = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
      try{
        let params = {
                        action: 'multipartSignPart',
                        partNumber: i+1,
                        contentLength: file.size, // need to check for content length case
                        sendBackData:{
                          uploadId: uploadId,
                          key:uploadUrl
                        }
                      };
        const data      = await uploadToAwsServer(accessToken, {}, params, configData.dms_api_url);
        const response  = await fetchChunk(data, chunk);

        // if (response) {
        //   console.log(response, 'chunk upload response consoled hereee');
        //   uploadedParts.push({ PartNumber: i + 1, ETag: response.headers.get("ETag") });
        //   setParts([...uploadedParts]);
        // } else {
        //   console.error("Failed to upload chunk");
        // }

      }catch(error) {
        setLoading(false);
        console.log("Error uploading chunk", error);
      }
    }
    completeUpload(uploadId, uploadUrl, fileUniqueName, originalFileName, itemId, itemParentId);
  }

  const completeUpload = async(uploadId, fileUploadUrl, fileUniqueName, originalFileName, itemId, itemParentId) => {
    try{
      let params = {
                      action: 'multipartComplete',
                      type: file.type,
                      requestType: 'blob',
                      sendBackData: {
                        uploadId: uploadId,
                        key: fileUploadUrl
                      }
                    }
      const data = await uploadToAwsServer(accessToken, {}, params, configData.dms_api_url);
      if(data?.ok) {
        let params      = {};
        let postParams  = {
                            account_id: configData.session.us_account_id,
                            parent_id: itemParentId,
                            item_type: '1',
                            owner_name: configData.session.us_name,
                            document_file_name: fileUniqueName,
                            orginal_filename: originalFileName,
                            org_group_id: configData.dms_setting.org_group_id,
                            org_id: configData.dms_setting.org_id,
                            owner_id: '1_user_'+configData.session.us_account_id+'_'+configData.id,
                            role_id: configData.session.us_role_id,
                            file_size: file.size,
                            id: itemId,
                            upload_type: 1,
                            owner_email: configData.session.us_email
                          }
        let response    = await saveDocument(accessToken, params, postParams, configData.dms_api_url);
        if(response) {
          setLoading(false);
          setShowDetailsOffcanvas(false);
          setSnackBarSuccessTitle('New Version Uploaded Successfully');
          toggleShowA();
        }
      }else {
        setLoading(false);
        console.log('Error upadation dms api', data);
      }
    }catch(error) {
      setLoading(false);
      console.log('Error while complete upload  ',error);
    }
  }

  useEffect(() => {
    if(file) {
      uploadFile(file);
    }
  },[file]);

  useEffect(() => {
    if(!bookmark_param) {
      fetchToken();
      if(accessToken) {
        fetchData();
      }
    }
  },[item_param,keyFilter,keyword]);

  useEffect(() => {
    if(bookmark_param) {
      setStarred(true);
      setActiveButton('grid');
      fetchToken();
      if(accessToken) {
        fetchStarredData();
      }
    }
  },[bookmark_param]);

  useEffect(() => {
    if(accessToken) {
      if(bookmark_param) {
        fetchStarredData();
      }else{
        fetchData();
      }
    }
  },[accessToken]);

  const fetchToken = async () => {
    try {
      if (learnerId) {
        const response = await getSPAuthTokens('dms', configData.access_token);
        if (response !== '') {
          setAccessToken(response);
        }
      }
    }catch(err) {
      console.log(err,'error while generate token');
    }
  }
  //function to fetch get shared items api
  const fetchData = async () => {
    let params              = {};
    let postParams          = {};
    postParams.key_filter   = keyFilter === 0 ? '' : keyFilter;
    postParams.user_name    = configData.session.us_name;
    postParams.user_email   = configData.session.us_email;
    postParams.account_name = learner.website.site_name;
    postParams.org_group_id = configData.dms_setting.org_group_id;
    postParams.org_id       = configData.dms_setting.org_id;
    postParams.owner_id     = '1_user_'+configData.session.us_account_id+'_'+configData.id;
    postParams.owner_name   = configData.session.us_name;
    postParams.item_id      = item_param && (parseInt(item_param,10) > 0)  ? parseInt(item_param,10) : 0;
    postParams.keyword      = keyword;
    postParams.device_type  = 0; // need to check for device type later
    postParams.account_id   = configData.session.us_account_id;
    postParams.role_id      = configData.session.us_role_id;
    postParams.owner_email  = configData.session.us_email;
    let itemShared = await getSharedItem(accessToken, params, postParams,configData.dms_api_url);
    if(itemShared && itemShared.data && itemShared.data.items && itemShared.data.items.length > 0) {
      let dropdownItemsFile = [
        { key: '1', label: 'Edit', icon: editIcon},
        { key: '2', label: 'Share', icon: shareOIcon},
        { key: '3', label: 'Download', icon: downloadIcon},
        { key: '4', label: 'Activity Logs', icon: uptrendIcon},
        { 
          key: '5', className: 'view-more-items', label: 'More Info', icon: exclamationIcon, 
            subItems: [
                { key: '6', label: 'Details', icon: exclamationIcon, eventKey:'details'},
                { key: '7', label: 'Version History', icon: versionClockIcon, eventKey:'version_history'}
            ]
        }
      ];
      let dropdownItemsFolder = [
        { key: '1', label: 'Edit', icon: editIcon},
        { key: '2', label: 'Share', icon: shareOIcon},
        { key: '4', label: 'Activity Logs', icon: uptrendIcon},
        { 
          key: '5', className: 'view-more-items', label: 'More Info', icon: exclamationIcon, 
            subItems: [
                { key: '6', label: 'Details', icon: exclamationIcon, eventKey:'details'}
            ]
        }
      ];

      let folderData = itemShared.data.items.filter(item => item.i_item_type === '0');
      folderData = folderData.map(item => {
        if(item.share_permission == "0") {
          dropdownItemsFolder = dropdownItemsFolder.filter(dItemFolder => dItemFolder.key !== '2');
        }
        if(item.access_type === "2") {
          dropdownItemsFolder = dropdownItemsFolder.filter(dItemFolder => dItemFolder.key !== '1');
        }
        return {...item, dropdownItems: dropdownItemsFolder}
      });

      let fileData = itemShared.data.items.filter(item => item.i_item_type === '1');
      fileData = fileData.map(item => {
        if(item.share_permission == "0") {
          dropdownItemsFile = dropdownItemsFile.filter(dItemFolder => dItemFolder.key !== '2');
        }
        if(item.access_type === "2") {
          dropdownItemsFile = dropdownItemsFile.filter(dItemFolder => dItemFolder.key !== '1');
        }
        return {...item, dropdownItems: dropdownItemsFile}
      });

      setItemSharedFolder(folderData);
      setItemSharedFile(fileData);
    }else {
      setItemSharedFolder([]);
      setItemSharedFile([]);
    }
    if(itemShared && itemShared.data.doc_searchfilter) {
      // Transform the object into an array of objects
      const formattedCategories = Object.entries(itemShared.data.doc_searchfilter).map(([key, value]) => ({
        id: parseInt(key, 10), // Convert key to a number
        name: value,
      }));
      // Append to the existing categories
      setCategories([{ id: 0, name: 'All Categories' }]);
      setCategories((prevCategories) => [...prevCategories, ...formattedCategories]);
    }
  };



  const fetchStarredData = async() => {
    let params = {};
    let postParams = {};
    postParams.account_name = learner.website.site_name;
    postParams.org_group_id = configData.dms_setting.org_group_id;
    postParams.org_id = configData.dms_setting.org_id;
    postParams.owner_id = '1_user_'+configData.session.us_account_id+'_'+configData.id;
    postParams.owner_name = configData.session.us_name;
    postParams.keyword = keyword;
    postParams.account_id = configData.session.us_account_id;
    postParams.role_id = configData.session.us_role_id;
    postParams.owner_email = configData.session.us_email;
    let itemStarred = await getStarredItem(accessToken, params, postParams, configData.dms_api_url);
    if(itemStarred.data.items && itemStarred.data.items.length > 0 ) {
      setItemSharedFolder([]);
      setItemSharedFile([]);
      const dropdownItemsFile = [
        { key: '4', label: 'Activity Logs', icon: uptrendIcon},
        { 
          key: '5', className: 'view-more-items', label: 'More Info', icon: exclamationIcon, 
            subItems: [
                { key: '6', label: 'Details', icon: exclamationIcon, eventKey:'details'},
                { key: '7', label: 'Version History', icon: versionClockIcon, eventKey:'version_history'}
            ]
        }
      ];
      const dropdownItemsFolder = [
        { key: '4', label: 'Activity Logs', icon: uptrendIcon},
        { 
          key: '5', className: 'view-more-items', label: 'More Info', icon: exclamationIcon, 
            subItems: [
                { key: '6', label: 'Details', icon: exclamationIcon, eventKey:'details'}
            ]
        }
      ];

      let folderData = itemStarred.data.items.filter(item => item.ib_item_type === '0' && item.item_access != '0');
      folderData = folderData.map(item => {
        return {...item, dropdownItems: dropdownItemsFolder}
      });

      let fileData = itemStarred.data.items.filter(item => item.ib_item_type === '1' && item.item_access != '0');
      fileData = fileData.map(item => {
        return {...item, dropdownItems: dropdownItemsFile}
      });

      setItemSharedFolder(folderData);
      setItemSharedFile(fileData);
    }else {
      setItemSharedFolder([]);
      setItemSharedFile([]);
    }
  }

  const toggleBookMark = async (data) => {
    setBookmarkData(data);
    setShowModalDelete(true);
    return;
    
  }

  const handleCloseModalDelete = () => {
    setShowModalDelete(false);
  }

  const handleSubmitModalDelete = async(data) => {
    let params = {};
    let postParams = {
        "org_group_id": configData.dms_setting.org_group_id,
        "org_id": configData.dms_setting.org_id,
        "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
        "item_id": data.item_id,
        "tab_name": "share_me",
        "role_id": configData.session.us_role_id,
        "owner_name": configData.session.us_name,
        "owner_email": configData.session.us_email,
        "status": !data.starred_detail
    };
    let itemStarred = await postStarredItem(accessToken, params, postParams, configData.dms_api_url);
    if(itemStarred.status == 200) {
      setShowModalDelete(false);
      //Todo: need to add toaster for success case
      if(bookmark_param) {
        setStarred(true);
        setActiveButton('grid');
        fetchStarredData();
      }else {
        fetchData();
      }
    }
  }

  const fetchItemDetails = async (itemId) => {
    let params = {};
    let postParams = {
      "org_group_id": configData.dms_setting.org_group_id,
      "org_id": configData.dms_setting.org_id,
      "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
      "owner_name": configData.session.us_name,
      "owner_email": configData.session.us_email,
      "role_id": configData.session.us_role_id,
      "account_name": learner.website.site_name,
      "account_id": configData.session.us_account_id,
      "item_id": itemId,
      "tab_name": "share_me"
    };
    let itemDetails = await getItemDetails(accessToken, params, postParams, configData.dms_api_url);
    if(itemDetails.status == 200) {
      setItemDetails(itemDetails.data);
    }
  }

  const fetchActivityLogs = async(itemId) => {
    let params = {};
    let postParams = {
      "org_group_id": configData.dms_setting.org_group_id,
      "org_id": configData.dms_setting.org_id,
      "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
      "account_id": configData.session.us_account_id,
      "draw": 1,
      "offset": 0,
      "limit": 100,
      "detail_view": 1,
      "item_id": itemId,
      "role_id": configData.session.us_role_id,
      "owner_name": configData.session.us_name,
      "owner_email": configData.session.us_email
    };
    let activityLogs = await getItemActivityLogs(accessToken, params, postParams, configData.dms_api_url);
    if(activityLogs.status == 200) {
      setActivityLogs(activityLogs.data);
    }
  }

  const shareDocuments = async(formData, itemDetail) => {
    let params = {};
    let postParams = {
      "itemid": itemDetail.itemId,
      "parentid": itemDetail.parentId,
      "share_with": 1,
      "user_email": formData.email,
      "user_email_org_id": "",
      "organisation_id": "",
      "org_roles": 0,
      "org_role_name": "",
      "access_type": formData.accessType,
      "share_permission": formData.sharePermission,
      "delete_permission": 0,
      "account_id": configData.session.us_account_id,
      "org_group_id": configData.dms_setting.org_group_id,
      "org_id": configData.dms_setting.org_id,
      "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
      "owner_name": configData.session.us_name,
      "owner_email": configData.session.us_email,
      "role_id": configData.session.us_role_id,
      "mail_to": configData.mail_email
    };
    let response = await postShareDocument(accessToken, params, postParams, configData.dms_api_url);
    if(response.status == "200") {
      closeModalShare();
      // Todo: need to add toaster for document shared successfully
    }
  }

  const getDocumentTypeSection = async(parentId) => {
    let params = {};
    let postParams = {
      "item_id": parentId,
      "org_group_id": configData.dms_setting.org_group_id,
      "org_id": configData.dms_setting.org_id,
      "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
      "account_id": configData.session.us_account_id,
      "owner_name": configData.session.us_name,
      "owner_email": configData.session.us_email,
      "role_id": configData.session.us_role_id
    };
    let response = await fetchDocumentTypeSection(accessToken, params, postParams, configData.dms_api_url);
    if(response.status == 200) {
      setDocumentTypeSection(response.data);
    }
  }

  const updateDocument = async(formData, itemDetail) => {
    let params = {};
    let postParams = {
      "id": itemDetail.itemId,
      "parent_id": itemDetail.parentId,
      "account_id": configData.session.us_account_id,
      "item_name": formData.itemName,
      "document_tags": formData.tagName ? formData.tagName : '',
      "orginal_filename": itemDetail.itemOriginalFilename,
      "document_type": formData.categoryId ? formData.categoryId: '',
      "document_type_name": formData.categoryName ? formData.categoryName : '',
      "section_id": formData.sectionId ? formData.sectionId : '',
      "section_name": formData.sectionName ? formData.sectionName : '',
      "version_id": '',//need to verify this with sharad dai
      "item_type": formData.itemType,
      "item_access_type": 4,
      "owner_id": '1_user_'+configData.session.us_account_id+'_'+configData.id,
      "org_group_id": configData.dms_setting.org_group_id,
      "org_id": configData.dms_setting.org_id,
      "owner_name": configData.session.us_name,
      "owner_email": configData.session.us_email,
      "role_id": configData.session.us_role_id
    };
    if(formData.itemType === "0") {
      postParams.folder_short_desc = formData.itemShortDesc;
    }
    let response = await postUpdateDocument(accessToken, params, postParams, configData.dms_api_url);
    if(response.status == "200") {
      if(formData.itemType === "0") {
        closeModalFolder()
      }else {
        closeModalFile();
      }
      fetchData();
      //Todo: need to add toaster for file updated successfully
    }
  }

  // Filter 
  const handleDropdownChange = (selectedItem) => {
    setKeyFilter(selectedItem.id);
  };

  const handleSearchChange = (query) => {
    setKeyword(query);
  };

  const handleClearSearch = () => {
      console.log('Search cleared');
  };

  const handleSortChange = (sortType) => {
    if(sortType === 'starred') {
      setStarred(true);
      setSearchParams({ bookmark: true });
      setActiveButton('grid');
      fetchStarredData();
    }else {
      setSearchParams({});
      setKeyFilter(0);
      setKeyword('');
      setStarred(false);
      fetchData();
    }
  };

  // BreadCrumbs
  const dmsPages = [
    { icon: homeIcon, label: "Home", url: "/student-dashboard/" },
    { icon: documents, label: "DMS" }
  ];

return (
  <>
  {noAccess ? <Error403 /> : (
  <>
  <BreadCrumbs pages={dmsPages} />
  <div className={`${className || ""} myk__stu-courses-wrapper myk__stu-dms-wrapper`}>
    {loading && <UploadLoader />}
    <Row>
      <Col xl={12} className="">
        <div className="myk_stu-page-header">
          <h2>{bookmark_param ? 'Bookmarks' : 'Shared with me'}</h2>
          <DocFilter
              className=""
              searchPlaceholder="Search by keywords, title or tags"
              dropdownLabel="Select Categories"
              dropdownItems={categories}
              onDropdownChange={handleDropdownChange}
              onSearchChange={handleSearchChange}
              onClearSearch={handleClearSearch}
              onSortChange={handleSortChange}
          />
        </div>
        <Row>
          <Col xl={12} className="mb-4">
            {item_param && parseInt(item_param,10) > 0  ? <h2><Button onClick={handleBack} variant="outline" className="dark bg-transparent btn-round btn-sm ps-3 px-4 mb-3" >{leftArrowLong} Go Back</Button><br/></h2> : ''}
            {itemSharedFolder && itemSharedFolder.length > 0 ? 
              <div>
                <div className="myk_stu-page-header myk__stu-dms_fol-header mb-3">
                  <h2>Folder</h2>
                </div>
                <div className="myk__stu-folders-container">
                  {itemSharedFolder && itemSharedFolder.length > 0 ? itemSharedFolder.map((item, index) => (
                    <div key={index} onClick={() => handleFolderClick(item)} style={{ cursor: "pointer" }}>
                    <DocFileFolderBlock 
                      item={item}
                      onDropdownClick={(event) => event.stopPropagation()}
                      starred  = {starred}
                      toggleBookMark={toggleBookMark}
                      handleOffcanvas={handleOffcanvas}
                      handleDropdownClick={handleDropdownClick}
                    />
                  </div>
                  )) : (
                  <div className="myk__stu-foldersfileslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                    <NoItems
                      icon={noTestData}
                      title="No Folders Available!"
                      description="There aren’t any folders to show!"
                    />
                  </div>
                  )}
                </div>
              </div> : ''
            }
          </Col>
          <Col xl={12}>
            <div className="myk_stu-page-header myk__stu-dms_fol-header mb-3">
              <h2>Files</h2>
              {!starred &&
              <div className="myk_stu-dms-grid_sort">
                <Button variant="icon" title="Grid view" role="button" className={`btn-dms_grid btn-dms_grid-block ${activeGridButton === "grid" ? "active" : ""}`} onClick={() => handleSortSelection("grid")}>
                  {gridIcon}
                </Button> 
                <Button variant="icon"  title="Table view" role="button" className={`btn-dms_grid btn-dms_grid-inline ${activeGridButton === "inline" ? "active" : ""}`} onClick={() => handleSortSelection("inline")}>
                  {menuHamburgerIcon}
                </Button>
              </div>}
            </div>
            {activeGridButton === "grid" ? (
            <div className="myk__stu-folders-container" id="grid-table_files">
              {itemSharedFile && itemSharedFile.length > 0 ? itemSharedFile.map((item, index) => (
                <DocFileFolderBlock key={index} item={item} onDropdownClick={(event) => event.stopPropagation()} starred = {starred} toggleBookMark={toggleBookMark} handleOffcanvas={handleOffcanvas} handleDropdownClick={handleDropdownClick}/>
              )) : (
                <div className="myk__stu-foldersfileslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                  <NoItems
                    icon={noReportBadgeInner}
                    title="No Files Available!"
                    description="There aren’t any files to show!"
                  />
                </div>
              )}
            </div>
            ):(
              <div className="myk__stu-grid_files-container " id="grid-files">
                {itemSharedFile && itemSharedFile.length > 0 ? 
                  <FilesGridTable items={itemSharedFile} categories={categories} toggleBookMark={toggleBookMark} handleDropdownClick={handleDropdownClick}/>
                : (
                  <div className="myk__stu-foldersfileslist-empty p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
                    <NoItems
                      icon={noReportBadgeInner}
                      title="No Files Available!"
                      description="There aren’t any files to show!"
                    />
                  </div>
                )}
              </div>
            )}
          </Col>
        </Row>
      </Col>
    </Row>
    {showDetailsOffcanvas &&  
      <DocDetailsOffcanvas 
        showDetailsOffcanvas={showDetailsOffcanvas} 
        setShowDetailsOffcanvas={setShowDetailsOffcanvas} 
        activeTabKey={activeTabKey}
        setActiveTabKey={setActiveTabKey}
        itemDetails={itemDetails}
        dmsConfig={configData.dms_setting}
        handleDropdownClick={handleDropdownClick}
        handleFileVersion={handleFileVersionChange}
      />
    }

    {showActivityLogOffcanvas && 
      <ActivityLogsOffcanvas
        showActivityLogOffcanvas={showActivityLogOffcanvas}
        setShowActivityLogOffcanvas={setShowActivityLogOffcanvas}
        activityLogs={activityLogs}
      />
    }
  
    {/* Modal Folder */}
    {isModalFolderOpen && 
      <ModalFolder 
        showModal={isModalFolderOpen} 
        setShowModal={setIsModalFolderOpen} 
        closeModal={closeModalFolder}
        folderDetail={fileDetail}
        updateDocument={updateDocument}
      />
    }

    {/* Modal Share */}
    {isModalShareOpen && 
      <ModalShare 
        showModal={isModalShareOpen}
        closeModal={closeModalShare}
        shareDocuments={shareDocuments}
        shareItemDetail={shareItemDetail}
      />
    }
    {/* Modal File */}
    {isModalFileOpen && 
      <ModalFile 
        showModal={isModalFileOpen} 
        setShowModalFile={setIsModalFileOpen} 
        closeModalFile={closeModalFile}
        documentTypeSection={documentTypeSection}
        fileDetail={fileDetail}
        updateDocument={updateDocument}
      />
    }
    {/* Modal Delete */}
    {showModalDelete && 
      <ModalDelete
          showModalDelete={showModalDelete}
          setShowModal={setShowModalDelete}
          handleCloseModalDelete={handleCloseModalDelete}
          handleSubmitModalDelete={handleSubmitModalDelete}
          bookmarkData={bookmarkData}
          title="Bookmark / UnBookmark Documents"
          message="Are you sure?"
      />
    }
    <ToastContainer position="bottom-center" className="custom-snackbar-success p-3 position-fixed zindex-high">
      <Toast variant="primary" show={showSuccessSnack} onClose={toggleShowA}>
        <Toast.Body>
          <ToastInfo toastDescription={snackBarSuccessTitle} />
          <div className="action-wrapper">
            <Button
              variant="primary"
              type="button"
              size="sm"
              className="btn-round bg-primary-fade"
              aria-label="Close"
              onClick={toggleShowA}
            >
              Close
            </Button>
          </div>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  </div>
  </>
  )}
  </>
);
}

export default DmsDashboard;